<template>
  <v-card flat class="auth-progs--header" color="transparent">
    <v-row align="center">
      <v-col cols="12">
        <v-toolbar flat color="grey lighten-2" class="px-2">
          <v-select hide-details
            v-model="form.author"
            label="相談担当者"
            class="mr-4"
            :items="getConsultantItems"
            item-text="name"
            item-value="userid"
            @change="search(1)"
          />
          <v-select hide-details
            v-model="form.arranger"
            label="手配担当者"
            :items="getArrangerItems"
            item-text="name"
            item-value="userid"
            @change="search(1)"
          />
          <v-spacer></v-spacer>
          <v-btn-toggle v-if="$vuetify.breakpoint.smAndUp" mandatory class="grey lighten-3" v-model="form.status" @change="search(1)">
            <v-btn :text="form.status !== 1" :depressed="form.status === 1" color="secondary white--text" :value="1">未完</v-btn>
            <v-btn :text="form.status !== 2" :depressed="form.status !== 2" color="secondary white--text" :value="2">完了</v-btn>
          </v-btn-toggle>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row dense align="center" class="mt-2">
      <v-col cols="12" sm="3" md="2" class="fm-in">
        <p class="caption grey--text text--darken-2">表示数</p>
        <v-btn-toggle mandatory dense class="transparent" v-model="form.limit" @change="search(1)">
          <v-btn :text="form.limit !== '10'" :depressed="form.limit === '10'" color="secondary white--text" value="10">10</v-btn>
          <v-btn :text="form.limit !== '50'" :depressed="form.limit === '50'" color="secondary white--text" value="50">50</v-btn>
          <v-btn :text="form.limit !== '100'" :depressed="form.limit === '100'" color="secondary white--text" value="100">100</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-spacer></v-spacer>
      <v-col v-if="!isLoading" cols="4" sm="2" class="py-2">
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">{{ printPageInfo }}</v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="searchFirstPage">
              <v-list-item-title class="caption text-center">最初</v-list-item-title>
            </v-list-item>
            <v-list-item @click="searchLastPage">
              <v-list-item-title class="caption text-center">最後</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col sm="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon color="secondary" :disabled="isLoading || !isAccessiblePrev" @click="prev">
              <v-icon small>fal fa-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>前へ</span>
        </v-tooltip>
      </v-col>
      <v-col sm="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon color="secondary" :disabled="isLoading || !isAccessibleNext" @click="next">
              <v-icon small>fal fa-chevron-right</v-icon>
            </v-btn>
          </template>
          <span>次へ</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-divider v-if="$vuetify.breakpoint.xsOnly"></v-divider>
  </v-card>
</template>

<script>
const DEF = {
  FORM: {
    author: '',
    arranger: '',
    status: 1,
    limit: '10',
    page: 1,
    size: 0
  }
}
export default {
  name: 'authorProgsToolbars',
  props: [
    'status'
  ],
  data () {
    return {
      form: {
        author: DEF.FORM.author,
        arranger: DEF.FORM.arranger,
        status: DEF.FORM.status,
        limit: DEF.FORM.limit,
        page: DEF.FORM.page,
        size: DEF.FORM.size
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      let roles = this.$store.getters['author/get']('roles')
      if (roles.includes('arranger')) {
        this.$set(this.form, 'arranger', this.$store.getters['author/get']('userid'))
      } else if (roles.includes('consultant')) {
        this.$set(this.form, 'author', this.$store.getters['author/get']('userid'))
      }
      this.$nextTick(() => {
        this.search()
      })
    },
    search: function (page) {
      if (this.$props.status && !this.$props.status.loading) {
        this.$nextTick(() => {
          let fm = this.getForm(page)
          this.$emit('emit', {
            action: 'get',
            data: fm
          })
        })
      }
    },
    searchFirstPage: function () {
      this.$set(this.form, 'page', 1)
      this.search(1)
    },
    searchLastPage: function () {
      const { limit, size } = this.form
      const last = Math.floor(size / limit) + ((size % limit) > 0 ? 1 : 0)
      this.$set(this.form, 'page', last)
      this.search(last)
    },
    prev: function () {
      let num = this.form.page
      if (num !== 1) {
        this.$set(this.form, 'page', num - 1)
        this.search(num - 1)
      }
    },
    next: function () {
      let num = this.form.page
      if (num !== this.form.size) {
        this.$set(this.form, 'page', num + 1)
        this.search(num + 1)
      }
    },
    count: function (size) {
      this.$set(this.form, 'size', size)
    },
    getForm: function (page) {
      return {
        author: this.form.author,
        arranger: this.form.arranger,
        status: this.form.status,
        limit: {
          offset: (page != null && Number.isFinite(page)) ? page : this.form.page,
          size: parseInt(this.form.limit)
        },
        page: (page != null && Number.isFinite(page)) ? page : this.form.page
      }
    }
  },
  computed: {
    isLoading () {
      return (this.$props.status && this.$props.status.loading)
    },
    isAccessibleNext () {
      return ((this.form.size - this.form.page * this.form.limit) > 0)
    },
    isAccessiblePrev () {
      return ((this.form.page - 1) > 0)
    },
    getConsultantItems () {
      let authors = this.$store.getters['config/get']('authors')
      return [{
        userid: '',
        name: '選択なし'
      }].concat(Object.keys(authors).filter(userid => {
        return authors[userid].roles.includes('consultant')
      }).map(userid => {
        return {
          userid,
          name: authors[userid].name[0]
        }
      }))
    },
    getArrangerItems () {
      let authors = this.$store.getters['config/get']('authors')
      return [{
        userid: '',
        name: '選択なし'
      }].concat(Object.keys(authors).filter(userid => {
        return authors[userid].roles.includes('arranger')
      }).map(userid => {
        return {
          userid,
          name: authors[userid].name[0]
        }
      }))
    },
    printFormStatus () {
      return this.form.status ? '完了' : '未完'
    },
    printPageInfo () {
      let limit = parseInt(this.form.limit)
      let num = this.form.page
      let st = limit * (num - 1) + 1
      let ed = Math.min(limit * num, this.form.size)
      return st + ' - ' + ed + ' / ' + this.form.size
    }
  }
}
</script>

<style lang="scss">
.auth-progs--header {
  .fm-in {
    position: relative;
    .caption {
      position: absolute;
      top: -1.2em;
    }
  }
}
</style>
